// ==================== XSS Protection Utility (Revised) ====================
const XSSProtection = {
    /**
     * HTML escape - converts special characters to HTML entities
     */
    escapeHTML: function(str) {
        if (!str) return str;
        
        const htmlChars = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        
        return String(str).replace(/[&<>"'`=\/]/g, function(char) {
            return htmlChars[char];
        });
    },

    /**
     * Check if input is safe (for validation on submit)
     * Note: This method only blocks submission, does not affect display
     */
    isInputSafe: function(input) {
        if (!input) return true;
        
        const inputStr = String(input);
        
        // Check for HTML tags
        if (/<[^>]*>/.test(inputStr)) {
            console.warn('Possible HTML tags detected');
            return false;
        }
        
        // Check for JavaScript events
        if (/\s+on\w+\s*=\s*["'][^"']*["']/i.test(inputStr)) {
            console.warn('Possible JavaScript events detected');
            return false;
        }
        
        // Check for javascript: protocol
        if (/javascript:/i.test(inputStr)) {
            console.warn('javascript: protocol detected');
            return false;
        }
        
        // Check for script tags
        if (/<script[^>]*>/i.test(inputStr)) {
            console.warn('script tags detected');
            return false;
        }
        
        return true;
    },

    /**
     * Sanitize input (remove dangerous content) - for before storing to database
     * Note: This modifies the original content
     */
    sanitizeInput: function(input) {
        if (!input) return input;
        
        let sanitized = String(input);
        
        // Define JavaScript events
        const jsEvents = [
            'onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout',
            'onfocus', 'onblur', 'onsubmit', 'onreset', 'onchange',
            'onkeydown', 'onkeyup', 'onkeypress', 'oncontextmenu'
        ];
        
        // Remove event attributes
        jsEvents.forEach(event => {
            const patterns = [
                new RegExp(`\\s+${event}\\s*=\\s*"[^"]*"`, 'gi'),
                new RegExp(`\\s+${event}\\s*=\\s*'[^']*'`, 'gi'),
                new RegExp(`\\s+${event}\\s*=\\s*[^\\s>]+`, 'gi')
            ];
            patterns.forEach(pattern => {
                sanitized = sanitized.replace(pattern, ' ');
            });
        });
        
        // Remove dangerous protocols
        sanitized = sanitized.replace(/javascript:/gi, '');
        sanitized = sanitized.replace(/data:text\/html/gi, '');
        
        // Remove script tags
        sanitized = sanitized.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
        
        return sanitized;
    },

    /**
     * Process user input - for storing to database or sending to server
     * Can choose whether to perform strict validation based on needs
     */
    processUserInput: function(input, options = {}) {
        const defaults = {
            trim: true,
            maxLength: 1000,
            strictMode: false,  // Strict mode off by default, allow displaying any content
            sanitize: false     // No sanitization by default, preserve original content
        };
        
        const settings = { ...defaults, ...options };
        
        if (!input) return '';
        
        let processed = String(input);
        
        if (settings.trim) {
            processed = processed.trim();
        }
        
        if (settings.maxLength > 0 && processed.length > settings.maxLength) {
            processed = processed.substring(0, settings.maxLength);
        }
        
        // Strict mode: if enabled and unsafe, throw error
        if (settings.strictMode && !this.isInputSafe(processed)) {
            throw new Error('Input contains unsafe content and has been blocked');
        }
        
        // If sanitization required, perform cleanup
        if (settings.sanitize) {
            processed = this.sanitizeInput(processed);
        }
        
        return processed;
    },

    /**
     * Safely display user input - core method!
     * Always use textContent to ensure any content is displayed as plain text
     */
    displayUserInput: function(element, text) {
        if (!element) return;
        
        element.textContent = text;
        
    },

    /**
     * Safely insert HTML (use only when content is confirmed safe)
     */
    safeInnerHTML: function(element, html) {
        if (!element) return;
        
        // Escape first then insert, ensure safety
        element.innerHTML = this.escapeHTML(html);
    },

    /**
     * Add real-time protection for input fields
     */
    protectInput: function(inputSelector) {
        const inputs = document.querySelectorAll(inputSelector);
        
        inputs.forEach(input => {
            // Only check on submit, does not affect input process
            const form = input.closest('form');
            if (form) {
                form.addEventListener('submit', (e) => {
                    if (!this.isInputSafe(input.value)) {
                        e.preventDefault();
                        alert('Input contains unsafe content, submission has been blocked');
                    }
                });
            }
            
            // Optional: warn on blur, but do not block input
            input.addEventListener('blur', () => {
                if (!this.isInputSafe(input.value)) {
                    console.warn('Input contains unsafe content and has been displayed as text');
                }
            });
        });
    }
};

export default XSSProtection